<template>
    <div depublishpage data-layout-type="regular" :data-layout-width="layout.LayoutWidth">
        <header :data-position="layout.HeaderAlignmentPublicName">
            <media
                v-if="layout.HeaderImagePath"
                data-logo
                :url="state.layout.HeaderImagePath"
                alt="Layout Logo"
                aria-hidden="true"
                type="Image"
            />
        </header>
        <languageswitcher v-if="state.languages !== undefined && state.languages.length > 1" />
        <main>
            <div data-main :data-text-position="layout.TextAlignmentPublicName">
                <h2 id="depublish-text">{{this.$store.getters.textResource(`rs_survey_is_depublished`)}}</h2>
                <a
                    data-button
                    data-styling-type="secondary"
                    :href="queueLink"
                    autofocus
                    id="restart-qlink"
                    :value="this.$store.getters.textResource(`rs_restart_survey`)"
                    :disabled="state.global.showLoader"
                >{{this.$store.getters.textResource(`rs_restart_survey`)}}</a>
            </div>
        </main>
        <footer v-if="layout.RemovePoweredBy !== true" data-crowdtech-logo>
             <a :href="state.surveyInfo.culture === `nl-NL` ? `https://welcome.crowdtech.com/pdc` : `https://welcome.crowdtech.com/pbc`" target="_blank">
                <media
                    :url="`${state.settings.assetPath}powered-by-crowdtech-logo-${constrastCheck}.svg`"
                    alt="Crowdtech logo"
                    type="Image"
                />
            </a>
        </footer>
    </div>
</template>

<script>
import media from "@/components/Media.vue";
import Vue from "vue";
import store from "@/store/store";
import methods from "@/global/methods.js";
import languageswitcher from "@/components/LanguageSwitcher.vue";

Vue.use(store.state.global.allowedHtml);

export default {
    name: `depublishpage-view`,
    components: {
        media,
        languageswitcher
    },
    computed: {
        queueLink: function () {
            return this.$route.params.queueLink;
        },
        state: function () {
            return this.$store.state;
        },
        layout: function () {
            return this.state.layout;
        },
        constrastCheck: function () {
            return methods.hexToRgb(this.layout.BackgroundColor);
        },
    },
    methods: {
    },
    created() {
        this.$store.commit(`changeGlobal`, {
            variableName: `showLoader`,
            newValue: false,
        });
    },
};
</script>

<style scoped>
h2:empty {
    display: none;
}

[data-main] {
    &[data-text-position="Left"] {
        align-items: flex-start;
        text-align: left;
    }

    &[data-text-position="Right"] {
        align-items: flex-end;
        text-align: right;
    }

    &[data-text-position="Center"] {
        align-items: center;
        text-align: center;
    }
}

[data-button] {
    text-decoration: none;
}

#restart-text {
    width: 100%;
}
</style>